angular.module('invoice')
    .constant('InvoiceSettlementConst', {
        eventUpdate: 'invoice-settlement.updated'
    })
    .factory('InvoiceSettlement', function ($resource) {
        return $resource('/crm/api/invoice-settlement/:id', {id: '@id'}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/invoice-settlement/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/invoice-settlement/table-statistics'},
            update: {method: 'PUT'},
            saveBatch: {method: 'POST', url: '/crm/api/invoice-settlement-batch'},
            waiting: {method: 'POST', url: '/crm/api/invoice-settlement/:id/waiting'},
            suggest: {method: 'POST', url: '/crm/api/invoice-settlement/:id/suggest'},
            pay: {method: 'POST', url: '/crm/api/invoice-settlement/:id/pay'},
            initiate: {method: 'POST', url: '/crm/api/invoice-settlement/:id/initiate'},
            paid: {method: 'POST', url: '/crm/api/invoice-settlement/:id/paid'},
            suspend: {method: 'POST', url: '/crm/api/invoice-settlement/:id/suspend'},
            deferred: {method: 'POST', url: '/crm/api/invoice-settlement/:id/deferred'},
        })
    })
    .component('invoiceSettlementStatusLabel', {
        bindings: {
            status: '<'
        },
        template: '<span class="label label-default invoice-settlement-status-label {{$ctrl.status}}">{{ \'invoice-settlement.status.\'.concat($ctrl.status) | translate }}</span>'
    })
    .service('InvoiceSettlementService', function ($rootScope, $cookies, toastr, modals, Invoice, InvoiceSettlement, ModuleSettings, FilesSimpleUploadService, InvoiceSettlementConst) {
        this.add = (invoice) => {
            return modals.open('app/invoice/settlement/add-modal.html', 'InvoiceSettlementDialogController', {invoiceId: invoice.id, invoice: invoice}, {size: "sm"}, "$ctrl")
        }
        this.delete = item => {
            modals.confirmDelete("wybrany rekord", () => Invoice.deleteSettlement({id: item.invoice.id, settlementId: item.id}).$promise.then(() => $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)))
        }
        this.isTransferable = type => {
            return ['TRANSFER', 'TRANSFER_EMPLOYEE', 'CARD'].includes(type)
        }
        this.waiting = item => {
            return modals.open('app/invoice/settlement/waiting-modal.html', 'InvoiceSettlementWaitingController', item, {size: "sm"}, "$ctrl")
        }
        this.suggest = item => {
            return modals.open('app/invoice/settlement/suggest-modal.html', 'InvoiceSettlementSuggestController', item, {size: "sm"}, "$ctrl")
        }
        this.pay = item => {
            return modals.open('app/invoice/settlement/pay-modal.html', 'InvoiceSettlementPayController', item, {size: "sm"}, "$ctrl")
        }
        this.initiate = item => {
            return modals.open('app/invoice/settlement/initiate-modal.html', 'InvoiceSettlementInitiateController', item, {size: "sm"}, "$ctrl")
        }
        this.paid = item => {
            return modals.open('app/invoice/settlement/paid-modal.html', 'InvoiceSettlementPaidController', item, {size: "sm"}, "$ctrl")
        }
        this.suspend = item => {
            let content = "Czy na pewno chcesz zmienić status rozliczenia dokumentu <b>" + item.invoice.number + "</b> na <b>WSTRZYMANE?</b>"
            modals.confirm(content, () => InvoiceSettlement.suspend({id: item.id}).$promise.then(() => $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)))
        }
        this.deferred = item => {
            return modals.open('app/invoice/settlement/deferred-modal.html', 'InvoiceSettlementDeferredController', item, {size: "sm"}, "$ctrl")
        }
        this.historyForInvoice = invoiceId => {
            return modals.open('app/invoice/settlement/history-modal.html', 'InvoiceSettlementHistoryController', { invoiceId: invoiceId }, {size: "lg"}, "$ctrl")
        }
        this.historyForSettlement = settlementId => {
            return modals.open('app/invoice/settlement/history-modal.html', 'InvoiceSettlementHistoryController', { settlementId: settlementId }, {size: "lg"}, "$ctrl")
        }
    })
    .controller('InvoiceSettlementAddController', function (data, $uibModalInstance, $scope, InvoiceSettlement, toastr, InvoiceSettlementConst) {
        this.$onInit = () => {
            this.invoice = data
        }
    })
    .controller('InvoiceSettlementDialogController', function ($rootScope, $uibModalInstance, Principal, Client, Invoice, InvoiceSettlementConst, InvoiceService, InvoiceSettlementService, data) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.Principal = Principal
        this.$onInit = () => {
            this.isAccountant = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING', 'ROLE_INVOICE_DOCUMENTS_ALL'])

            this.invoiceId = data.invoiceId
            this.invoice = data.invoice
            this.pricing = data.invoice.pricing
            this.settlementsAmount = data.invoice.settlementsAmount
            this.paidAmount = data.invoice.paidAmount
            this.bankAccounts = []

            this.item = {
                currency: "PLN",
                amount: {
                    totalNet: this.invoice.settlementsAmountLeft?.totalNet || 0,
                    totalVat: this.invoice.settlementsAmountLeft?.totalVat || 0,
                    totalGross: this.invoice.settlementsAmountLeft?.totalGross || 0,
                }
            }

            if (this.isAccountant === true && this.invoice.buyer?.client?.id != null) {
                Client.get({id: this.invoice.buyer.client.id}).$promise.then(c => {
                    this.bankAccounts = c.bankAccounts
                })
            }

            this.onPrivateCashChanged()
        }

        this.onPaymentTypeChanged = () => {
            switch (this.item.type) {
                case 'CASH_EMPLOYEE':
                    this.statuses = ['WAITING']
                    break
                case 'TRANSFER_EMPLOYEE':
                    this.statuses = ['WAITING']
                    break
                case 'CASH':
                    this.statuses = ['PAID']
                    break
                case 'TRANSFER':
                    this.statuses = this.isAccountant === true ? ['WAITING', 'INITIATED'] : ['INITIATED']
                    break
                case 'CARD':
                    this.statuses = ['INITIATED']
                    break
                case 'COMPENSATION':
                    this.statuses = ['PAID']
                    break;
                default:
                    this.statuses = []
                    break
            }

            if (this.item.type === 'TRANSFER' || this.item.type === 'TRANSFER_EMPLOYEE') {
                // let primaryBankAccount = this.bankAccounts.find(ba => ba.primary);
                // let formBankAccount = {
                //     bankAccountId: primaryBankAccount?.id
                // }
                // if (this.item.bankAccountId == null)
                //     angular.extend(this.item, formBankAccount)
            } else {
                // delete this.item.bankAccountId
                delete this.item.bankAccountOwner
            }

            if (this.statuses.length === 1) {
                this.item.status = this.statuses[0]
            } else {
                this.item.status = null
            }
            this.onStatusChanged()
        }

        this.calculate = () => {
            this.settlementOverdueConfirmation = false
            let settlementsAmountLeftVat = this.invoice.settlementsAmountLeft?.totalVat || 0
            let settlementsAmountLeftGross = this.invoice.settlementsAmountLeft?.totalGross || 0

            let multiplier = settlementsAmountLeftGross !== 0? settlementsAmountLeftVat / settlementsAmountLeftGross : 0
            this.item.amount.totalVat = InvoiceService.multiply(this.item.amount.totalGross || 0, multiplier)
            this.item.amount.totalNet = InvoiceService.sub(this.item.amount.totalGross || 0, this.item.amount.totalVat)
        }
        this.calculateVatChanged = () => {
            this.settlementOverdueConfirmation = false
            this.item.amount.totalNet = InvoiceService.sub(this.item.amount.totalGross, this.item.amount.totalVat)
        }
        this.isOverdue = () => {
            return this.item.amount.totalGross > this.invoice.settlementsAmountLeft.totalGross ||
                this.item.amount.totalNet > this.invoice.settlementsAmountLeft.totalNet ||
                this.item.amount.totalVat > this.invoice.settlementsAmountLeft.totalVat
        }
        this.onPrivateCashChanged = () => {
            if (this.item.privateCash === true) {
                this.settlementTypes = ['CASH_EMPLOYEE', 'TRANSFER_EMPLOYEE']
            } else {
                let workerSettlementTypes = ['CASH', 'TRANSFER', 'CARD']
                let accountantSettlementTypes = ['CASH', 'TRANSFER', 'CARD', 'COMPENSATION']
                this.settlementTypes = this.isAccountant === true ? accountantSettlementTypes : workerSettlementTypes
            }
            this.item.type = null
            delete this.item.cashOwner
            this.onPaymentTypeChanged()
        }

        this.enableAccountantAmountFields = () => {
            this.accountantAmountFields = true
        }
        this.disableAccountantAmountFields = () => {
            this.calculate()
            delete this.accountantAmountFields
        }

        this.onStatusChanged = () => {
            if (this.item.status === 'WAITING') {
                this.item.waiting = {
                    paymentDate: this.invoice.payment.deadline
                }
                if (this.isAccountant === true && this.InvoiceSettlementService.isTransferable(this.item.type)) {
                    let primaryBankAccount = this.bankAccounts.find(ba => ba.primary === true && ba.active === true);
                    this.item.waiting.bankAccountId = primaryBankAccount?.id
                }
            } else {
                delete this.item.waiting
            }
        }
        this.isEmployeePayment = () => {
            return ['CASH_EMPLOYEE', 'TRANSFER_EMPLOYEE'].includes(this.item.type)
        }
        this.isInitiatedTransfer = () => {
            return this.item.status === 'INITIATED' && this.item.type === 'TRANSFER'
        }
        this.save = () => {
            return Invoice.saveSettlement({id: this.invoiceId}, this.item).$promise.then(() => {
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
                $uibModalInstance.close()
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('InvoiceSettlementWaitingController', function (data, $uibModalInstance, $rootScope, $scope, Client, InvoiceSettlementService, InvoiceSettlement, toastr, InvoiceSettlementConst) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                status: 'WAITING',
                bankAccountId: data.bankAccountId
            }
            Client.get({id: this.item.invoice.buyer.client.id}).$promise.then(c => {
                this.bankAccounts = c.bankAccounts
                if (this.form.bankAccountId == null) {
                    this.form.bankAccountId = this.bankAccounts.find(ba => ba.primary)?.id
                }
            })
        }
        this.save = () => {
            InvoiceSettlement.waiting({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('InvoiceSettlementSuggestController', function (data, $uibModalInstance, $rootScope, $scope, Client, InvoiceSettlement, InvoiceSettlementService, toastr, InvoiceSettlementConst) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                status: 'SUGGESTED',
                bankAccountId: data.bankAccountId
            }
            Client.get({id: this.item.invoice.buyer.client.id}).$promise.then(c => {
                this.bankAccounts = c.bankAccounts
                if (this.form.bankAccountId == null) {
                    this.form.bankAccountId = this.bankAccounts.find(ba => ba.primary)?.id
                }
            })
        }
        this.save = () => {
            InvoiceSettlement.suggest({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('InvoiceSettlementPayController', function (data, $uibModalInstance, $rootScope, $scope, Client, InvoiceSettlement, InvoiceSettlementService, toastr, InvoiceSettlementConst) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                status: 'TO_PAY',
                bankAccountId: data.bankAccountId
            }
            Client.get({id: this.item.invoice.buyer.client.id}).$promise.then(c => {
                this.bankAccounts = c.bankAccounts
                if (this.form.bankAccountId == null) {
                    this.form.bankAccountId = this.bankAccounts.find(ba => ba.primary)?.id
                }
            })
        }
        this.save = () => {
            InvoiceSettlement.pay({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('InvoiceSettlementInitiateController', function (data, $uibModalInstance, $rootScope, $scope, Client, InvoiceSettlement, InvoiceSettlementService, toastr, InvoiceSettlementConst) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                status: 'INITIATED',
                bankAccountId: data.bankAccountId
            }
            Client.get({id: this.item.invoice.buyer.client.id}).$promise.then(c => {
                this.bankAccounts = c.bankAccounts
                if (this.form.bankAccountId == null) {
                    this.form.bankAccountId = this.bankAccounts.find(ba => ba.primary)?.id
                }
            })
        }
        this.save = () => {
            InvoiceSettlement.initiate({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('InvoiceSettlementDeferredController', function (data, $uibModalInstance, $rootScope, Client, InvoiceSettlement, InvoiceSettlementService, InvoiceSettlementConst) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                status: 'DEFERRED',
                bankAccountId: data.bankAccountId
            }
            Client.get({id: this.item.invoice.buyer.client.id}).$promise.then(c => {
                this.bankAccounts = c.bankAccounts
                if (this.form.bankAccountId == null) {
                    this.form.bankAccountId = this.bankAccounts.find(ba => ba.primary)?.id
                }
            })
        }
        this.save = () => {
            InvoiceSettlement.deferred({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('InvoiceSettlementPaidController', function (data, $uibModalInstance, $rootScope, $scope, Client, InvoiceSettlement, InvoiceSettlementService, toastr, InvoiceSettlementConst) {
        this.InvoiceSettlementService = InvoiceSettlementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                status: 'PAID',
                bankAccountId: data.bankAccountId
            }
            Client.get({id: this.item.invoice.buyer.client.id}).$promise.then(c => {
                this.bankAccounts = c.bankAccounts
                if (this.form.bankAccountId == null) {
                    this.form.bankAccountId = this.bankAccounts.find(ba => ba.primary)?.id
                }
            })
        }
        this.save = () => {
            InvoiceSettlement.paid({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast(InvoiceSettlementConst.eventUpdate)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .component('invoiceSettlementList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/invoice/settlement/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, Invoice, InvoiceService, InvoiceSettlementService, Currency, InvoiceSettlementConst, TableSelection) {
            this.reset = () => this.filters = {filter: this.filters.filter}
            this.InvoiceService = InvoiceService
            this.InvoiceSettlementService = InvoiceSettlementService
            this.pricingSummaryProperties = ['net', 'vat', 'gross']

            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list, selected => {
                    this.statistics.selected = InvoiceService.sumInvoicesByCurrency(selected.map(item => ({currency: item.invoice?.currency, pricing: item.amount})))
                })
                this.settlementTypes = ['CASH_EMPLOYEE', 'TRANSFER_EMPLOYEE', 'CASH', 'TRANSFER', 'CARD']
                Currency.list().$promise.then(items => items.map(c => c.symbol)).then(items => this.currencies = items)
                Invoice.statuses().$promise.then(items => this.documentStatuses = items)
                Invoice.types().$promise.then(items => this.documentTypes = items)
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-settlement-batch/export?" + $httpParamSerializer(paramsAll)
            }
            this.getExportWithCostsUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-settlement-batch/export-with-costs?" + $httpParamSerializer(paramsAll)
            }


            this.searchFieldPopover = `
                <div>Prefiksy:</div>
                <div><b>df*</b> - nr dokumentu</div>
                <div><b>fvz*</b> - nr dok. księg.</div>
                <div><b>spr*</b> - sprzedawca (symbol, nazwa, nip)</div>
                <div><b>nab*</b> - nabywca (symbol, nazwa, nip)</div>
                <div><b>net*</b> - wartość netto od__do</div>
                <div><b>vat*</b> - wartość VAT od__do</div>
                <div><b>bru*</b> - wartość brutto od__do</div>
            `

            $scope.$on(InvoiceSettlementConst.eventUpdate, () => $state.reload())
        }
    })
    .component('invoiceSettlementBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/invoice/settlement/_btn-options.html',
        controller: function ($filter, InvoiceService, InvoiceSettlementService, InvoiceWorkflow, Principal) {
            this.InvoiceService = InvoiceService
            this.InvoiceSettlementService = InvoiceSettlementService
            this.Principal = Principal

            const updateWorkflowState = configuration => {
                const statuses = configuration ? configuration.settlements.processingAllowedStatuses : []
                this.isInvoiceStatusAllowSettlementChange = statuses.includes(this.item.invoice.status)
                this.processingAllowedStatusesTooltip = statuses.length
                    ? `Edycja możliwa w statusach DF: ${statuses.map(status => $filter('translate')(`invoice.status.${status}`)).join(', ')}`
                    : 'Edycja rozliczeń nie jest dozwolona w żadnym statusie dokumentu'
            }

            this.$onInit = () => {
                Principal.currentUser().then(user => {
                    this.isWorker = this.item.invoice.worker.id === user.id
                })
                this.isAccountant = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING'])
                this.isManager = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ALL', 'ROLE_ADMIN'])
                this.isAccountantOrManager = this.isAccountant || this.isManager
                InvoiceWorkflow.load().then(updateWorkflowState)
            }

            this.$onChanges = () => {
                this.isTransferable = InvoiceSettlementService.isTransferable(this.item.type)
                updateWorkflowState(InvoiceWorkflow.configuration)
            }

            this.canWaiting = () => {
                return this.isAccountantOrManager && ['SUGGESTED', 'SUSPENDED', 'DEFERRED'].includes(this.item.status)
            }

            this.canSuggest = () => {
                return this.isAccountantOrManager && ['WAITING', 'SUSPENDED', 'DEFERRED'].includes(this.item.status)
            }

            this.canPay = () => {
                return this.isAccountantOrManager && ['WAITING', 'SUGGESTED'].includes(this.item.status)
            }

            this.canInitiate = () => {
                return this.isAccountantOrManager && ['TO_PAY'].includes(this.item.status)
            }

            this.canPaid = () => {
                let isTransferableInitiated = this.isTransferable && ['INITIATED'].includes(this.item.status);
                let isNotTransferable = !this.isTransferable && !['PAID'].includes(this.item.status);
                return this.isAccountantOrManager && (isTransferableInitiated || isNotTransferable)
            }

            this.canSuspend = () => {
                return this.isAccountantOrManager && ['WAITING', 'SUGGESTED', 'TO_PAY', 'DEFERRED'].includes(this.item.status)
            }

            this.canDeferred = () => {
                return this.isAccountantOrManager && ['WAITING', 'SUGGESTED', 'TO_PAY', 'SUSPENDED'].includes(this.item.status)
            }

            this.canEdit = () => {
                // return this.isAccountantOrManager && !['PAID'].includes(this.item.status)
                return false
            }
            this.canDelete = () => {
                return this.isWorker || this.isAccountantOrManager
            }

            this.canSeeHistory = () => {
                return this.isAccountantOrManager
            }
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceSettlementList', {
            parent: 'app',
            url: '/invoice-settlement?{page:int}&{size:int}&sort&search&periodStart&periodEnd&status&type&documentType&currency&worker&seller&buyer&filter&documentStatus&customFilter',
            data: {
                authorities: ['ROLE_INVOICE_DOCUMENTS_ACCOUNTING', 'ROLE_INVOICE_DOCUMENTS_ALL']
            },
            params: {
                status: {array: true, value: [], squash: false},
                documentType: {array: true, value: [], squash: false},
                documentStatus: {array: true, value: null, squash: true},
                filter: {value: 'company-assigned'}
            },
            views: {
                'content@': 'invoiceSettlementList'
            },
            resolve: {
                filters: (InvoiceWorkflow, $stateParams) => InvoiceWorkflow.load().then(configuration => {
                    let filters = angular.copy($stateParams)
                    if (filters.documentStatus == null || filters.documentStatus === 'null' || (filters.documentStatus.length === 1 && filters.documentStatus[0] === 'null')) {
                        filters.documentStatus = configuration.settlements.processingAllowedStatuses
                    }
                    return filters
                }),
                statistics: (InvoiceSettlement, filters) => InvoiceSettlement.tableStatistics(angular.copy(filters)).$promise,
                page: (InvoiceSettlement, filters) => InvoiceSettlement.table(angular.copy(filters)).$promise
            }
        })
    })
